import { ResizeObserver } from '@juggle/resize-observer';
import * as React from 'react';

export function useMapViewportFit(map: YMaps.Map): void {
  React.useEffect(() => {
    const parentElement = map.container.getParentElement();
    const observer = new ResizeObserver(() => {
      map.container.fitToViewport();
    });

    observer.observe(parentElement);

    return () => {
      observer.disconnect();
    };
  }, [map]);
}
